// @ts-nocheck
import { toast } from 'sonner';

export const useAdminToast = () => {
  const showSuccess = (message: string) => {
    toast.success(message, {
      duration: 3000,
    });
  };

  const showError = (message: string) => {
    toast.error(message, {
      duration: 5000,
    });
  };

  const showInfo = (message: string) => {
    toast.info(message, {
      duration: 3000,
    });
  };

  return {
    showSuccess,
    showError,
    showInfo,
  };
};

